import { Button, Form, Input, message, Modal } from 'antd';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import IntlMessage from '../../../components/IntlMessage';
import busOrdersApi from '../../../api/bus_orders';
import userOperatorApi from '../../../api/user-operator';

const ChangePasswordForm = (props) => {
  const { isShowModalPassword, onModalClose } = props;
  const [form] = Form.useForm();

  const isMobile = window.innerWidth < 576;

  const handleOk = async () => {
    form
      .validateFields()
      .then(async (values) => {
        const res = await userOperatorApi.changePassword(values);
        if (res) {
          onModalClose();
          message.success('Mot de passe mis à jour avec succès!');
        } else {
          throw new Error('La mise à jour a échoué');
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
        if (info?.status === 474) {
          message.error('Le mot de passe actuel est incorrect');
        } else {
          message.error('La mise à jour a échoué');
        }
      });
  };

  useEffect(() => {
    form.resetFields();
  }, [form]);

  return (
    <Modal
      title={<IntlMessage id="global.changepassword" />}
      open={isShowModalPassword}
      destroyOnClose={true}
      onCancel={onModalClose}
      style={{ width: '100%', maxWidth: isMobile ? 360 : 1000 }}
      footer={[
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          // loading={loading}
          onClick={handleOk}>
          {<IntlMessage id="global.save" />}
        </Button>,
      ]}>
      <Form
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        labelAlign="left"
        form={form}
        name="control-hooks">
        <>
          <Form.Item
            // label={<IntlMessage id="global.password" />}
            name="password"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.password_required" />,
              },
            ]}>
            <Input.Password placeholder="Mot de passe actuel" />
          </Form.Item>
          <Form.Item
            // label={<IntlMessage id="global.new_password" />}
            name="new_password"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.password_required" />,
              },
            ]}>
            <Input.Password placeholder="Nouveau mot de passe" />
          </Form.Item>
          <Form.Item
            // label={<IntlMessage id="global.confirm_new_password" />}
            name="confirm_new_password"
            dependencies={['new_password']}
            hasFeedback
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.password_required" />,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error('Les mots de passe ne correspondent pas')
                  );
                },
              }),
            ]}>
            <Input.Password placeholder="Répéter le mot de passe" />
          </Form.Item>
        </>
      </Form>
    </Modal>
  );
};

export default ChangePasswordForm;
